import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import AdCarouselItem from 'components/pages/Home/AdsCarousel/AdCarouselItem';

import useAdBanner from 'hooks/useAdBanner';

const AdsCarousel = dynamic(() => import('components/pages/Home/AdsCarousel'), {
  ssr: true,
});

const SmallAds = ({ banners, gaEventCategory }) => {
  const { isAdBannerVisible } = useAdBanner();

  const visibleAds = useMemo(
    () => banners.filter(isAdBannerVisible),
    [banners, isAdBannerVisible]
  );

  if (!visibleAds.length) {
    return null;
  }

  /**
   * No need to use carousel for single ad.
   */
  if (visibleAds.length === 1) {
    const {
      id,
      url,
      description,
      image,
      mobileImage,
      tabletImage,
      visibility,
    } = visibleAds[0];

    return (
      <AdCarouselItem
        key={id}
        description={description}
        desktopImage={image}
        gaEventCategory={gaEventCategory}
        id={id}
        mobileImage={mobileImage}
        position={0}
        tabletImage={tabletImage}
        url={url}
        visibility={visibility}
        priority
      />
    );
  }

  return <AdsCarousel ads={visibleAds} gaEventCategory={gaEventCategory} />;
};

SmallAds.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      position: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      longUrl: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      mobileImage: PropTypes.string.isRequired,
      tabletImage: PropTypes.string.isRequired,
      bgColor: PropTypes.array,
      isClosable: PropTypes.bool.isRequired,
      type: PropTypes.string.isRequired,
      storeSlug: PropTypes.string,
      event: PropTypes.string.isRequired,
      height: PropTypes.string,
      visibility: PropTypes.string.isRequired,
    })
  ).isRequired,
  gaEventCategory: PropTypes.string.isRequired,
};

export default SmallAds;
